import { render, staticRenderFns } from "./ResellerCapacity.vue?vue&type=template&id=6dee615a"
import script from "./ResellerCapacity.vue?vue&type=script&lang=js"
export * from "./ResellerCapacity.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports